<template>
  <div class="app-main app-container">
    <header-container></header-container>
    <main-container></main-container>
    <footer-container></footer-container>
    <copy-right></copy-right>
    <back-top></back-top>
  </div>
</template>

<script>
  import ElScrollbar from "element-ui/packages/scrollbar/src/main";

  const CopyRight = () => import(/* webpackChunkName: "mainLayer" */ '@/components/CopyRight')
  const HeaderContainer = () => import(/* webpackChunkName: "mainLayer" */ '@/components/HeaderContainer')
  const MainContainer = () => import(/* webpackChunkName: "mainLayer" */ '@/components/MainContainer')
  const FooterContainer = () => import(/* webpackChunkName: "mainLayer" */ '@/components/FooterContainer')
  const BackTop = () => import(/* webpackChunkName: "BackTop" */ '@/components/BackTop')
  export default {
    name: 'app',
    components: {
      ElScrollbar,
      HeaderContainer,
      MainContainer,
      FooterContainer,
      CopyRight,
      BackTop,
    },
    data () {
      return {}
    },
    created: function () {
    },
    mounted () {
    },
    destoryed () {
    },
    methods: {}
  }
</script>

<style lang="scss">
  .section-block {
    text-align: center;
    h2 {
      height: 66px;
      font-size: 35px;
      font-weight: 500;
      color: rgba(3, 35, 64, 1);
      line-height: 49px;
      position: relative;
      &:after {
        position: absolute;
        content: '';
        display: block;
        width: 139px;
        height: 4px;
        left: 50%;
        bottom: 0;
        margin-left: -70px;
        border-radius: 3px;
        background: linear-gradient(90deg, rgba(7, 73, 116, 0), rgba(3, 35, 64, 1));
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue